import React, { useContext, useEffect, useRef } from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MinimizeIcon from "@mui/icons-material/Minimize";
import MaximizeIcon from "@mui/icons-material/Maximize";
import { useDispatch, useSelector } from "react-redux";
import { hideChat } from "../../../action/chat";
import {
  getAudienceId,
  getUserId,
  isMobile,
  putStreamRecord,
  truncate,
} from "../../../constants/function";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MusicNoteAnimation from "../MusicNoteAnimation";
import { SocketContext } from "../../../context/socket";
export default function StreamHeader({
  title,
  leaveStreaming,
  isOwner,
  onMinimise,
  onCloseFullScreen,
  isJoined,
  onNftClose,
  playlistId,
  streamSong,
  obs,
}) {
  const { songs, index, track } = useSelector((state) => state.streamSong);
  const liveUsers = useRef([]);
  const socket = useContext(SocketContext).Socket;
  const { t } = useTranslation("common");
  const history = useHistory();
  const [isMinimised, setIsMinimised] = React.useState(false);
  const [phone, setPhone] = React.useState(false);
  const dispatch = useDispatch();
  const [songData, setSongData] = React.useState({});
  const minimise = async () => {
    try {
      await onCloseFullScreen(false);
      const doc = document.getElementById("__steaming_container");
      doc.style.height = "60px";
      if (window.innerWidth < 576) doc.style.width = "100%";
      else doc.style.width = "30%";
      doc.style.left = "0";
      const _streamTippers = document.getElementById("_streamTippers");
      const _streaming_control = document.getElementById("_streaming_control");
      const _streaming_canvas = document.getElementById("_streaming_canvas");
      _streamTippers.style.display = "none";
      _streaming_control.style.display = "none";
      _streaming_canvas.style.display = "none";
      setIsMinimised(true);
      onNftClose();
    } catch (error) {}
  };
  const maximise = async () => {
    try {
      // dispatch(hideChat(true));

      const doc = document.getElementById("__steaming_container");
      if (window.innerWidth < 576) {
        doc.style.height = "100%";
        doc.style.width = "100%";
      } else {
        // doc.style.height = "calc(100% - 105px)";
        doc.style.height = "calc(100% - 60px)";

        doc.style.width = "calc(100% - 260px)";
      }
      doc.style.left = "unset";
      const _streamTippers = document.getElementById("_streamTippers");
      const _streaming_control = document.getElementById("_streaming_control");
      const _streaming_canvas = document.getElementById("_streaming_canvas");
      _streamTippers.style.display = "block";
      _streaming_control.style.display = "flex";
      _streaming_canvas.style.display = "flex";
      setIsMinimised(false);
    } catch (error) {}
  };
  useEffect(() => {
    if (
      isJoined &&
      isOwner &&
      history.location.pathname.includes("/LiveVideoStreaming")
    ) {
      setPhone(true);
      const shareScreenBtn = document.getElementById("_share_screen_btn");
      if (shareScreenBtn) shareScreenBtn.style.display = "none";
    }
  }, [isJoined]);

  useEffect(() => {
    if (socket) {
      socket.on("song-started", (data) => {
        if (data.roomId === playlistId) setSongData({ ...data });
      });
      socket.on("audience-in-stream", handleAudience);
    }
    if (streamSong) {
      setSongData({ ...streamSong });
    }
  }, [socket, streamSong]);
  const handleAudience = (data) => {
    if (
      data.channelName &&
      data.channelName === playlistId &&
      data.liveUsers.length !== liveUsers.current.length
    ) {
      console.log(track);
      // const playingIndex = songs.findIndex((obj) => obj.isPlaying);
      const playingIndex = localStorage.getItem("streamIndex");
      if (songs.length > 0 && playingIndex && playingIndex >= 0) {
        const curretTimeInSong = parseFloat(
          localStorage.getItem("curretTimeInSong")
        );
        putRecord(
          "stop",
          songs[playingIndex]._id,
          playlistId,
          playingIndex,
          curretTimeInSong ? curretTimeInSong : 0,
          new Date().getTime(),
          songs,
          liveUsers.current
        );
        putRecord(
          "start",
          songs[playingIndex]._id,
          playlistId,
          playingIndex,
          curretTimeInSong ? curretTimeInSong : 0,
          new Date().getTime(),
          songs,
          data.liveUsers
        );
      }
      liveUsers.current = data.liveUsers;
    }
  };
  const putRecord = async (
    event,
    musicId,
    playlistId,
    index,
    timeInSong,
    associationId,
    playlistSongs,
    liveUserData
  ) => {
    const userId = getUserId();
    const audienceArray = await getAudienceId(liveUserData);
    const payload = {
      eventType: event,
      timestamp: new Date().getTime(),
      userId: userId,
      musicId: musicId,
      playlistId: playlistId,
      livestreamId: playlistId,
      songDetails: playlistSongs[index],
      timeInSong: timeInSong,
      associationId: associationId,
      audienceArray: audienceArray,
    };
    putStreamRecord(payload);
  };
  return (
    <Stack
      className="_streaming_header"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        borderBottom: isMinimised ? "0px !important" : "1px solid #FFFFFF19",
      }}
    >
      <Stack
        className="_streaming_header_container"
        alignItems="center"
        spacing={1}
        direction="row"
      >
        <span></span>

        <Typography className="fs-17" title={isMinimised ? title : ""}>
          {isMinimised ? truncate(title, 20) : title}
        </Typography>
      </Stack>
      {isOwner ? (
        <Stack direction="row" alignItems="center">
          {!phone ? (
            <IconButton
              title={isMinimised ? t("stream.tooltip1") : t("stream.tooltip2")}
              onClick={() => (isMinimised ? maximise() : minimise())}
            >
              {isMinimised ? (
                <MaximizeIcon className="_cp" color="default" />
              ) : (
                <MinimizeIcon className="_cp" color="default" />
              )}
            </IconButton>
          ) : null}
          {isJoined || obs ? (
            <IconButton
              title={t("stream.tooltip3")}
              onClick={() => leaveStreaming()}
            >
              <CloseIcon className="_cp" color="default" />
            </IconButton>
          ) : null}
        </Stack>
      ) : null}
      {!isOwner && songData?.song ? (
        <MusicNoteAnimation song={songData} />
      ) : null}
    </Stack>
  );
}
